import MainView from '@/views/saverium_dk/MainView'
import LoanView from '@/views/saverium_dk/LoanView'
import OurPartnersView from '@/views/saverium_dk/OurPartnersView'
import FaqView from '@/views/saverium_dk/FaqView'
import LoginView from '@/views/LoginView'
import ResetPasswordView from '@/views/ResetPasswordView'
import SetPasswordView from '@/views/SetPasswordView'
import MyAccountView from '@/views/MyAccountView'
import LogoutView from '@/views/LogoutView'
import TosView from '@/views/saverium_dk/TosView'
import PrivacyPolicyView from '@/views/saverium_dk/PrivacyPolicyView'
import routeUtils from '@/router/routeUtils'

// Translations for paths, will be used as link urls
const localizedPaths = {
  MainView: '/',
  LoanView: '/loan',
  OurPartnersView: '/our-partners',
  FaqView: '/faq',
  LoginView: '/login',
  ResetPasswordView: '/reset_password',
  SetPasswordView: '/set_password/:pk/:key/:ts',
  MyAccountView: '/account',
  MyAccountTokenLoginView: '/account/:token',
  LogoutView: '/logout',
  TosView: '/terms-and-services',
  PrivacyPolicyView: '/privacypolicy',
}

/**
 * This object defains what site spesific routes you have and translations for those.
 * All routes must also have corresponding translation
 */
let langRoutes = [
  {
    name: 'MainView',
    component: MainView,
    meta: {
      isPublic: true,
      title: 'Saverium.dk',
    },
  },
  {
    name: 'LoanView',
    component: LoanView,
    meta: {
      isPublic: true,
      title: 'Apply for a loan - Saverium.dk',
    },
  },
  {
    name: 'OurPartnersView',
    component: OurPartnersView,
    meta: {
      title: 'Our partners - Saverium.dk',
      isPublic: true,
    },
  },
  {
    name: 'FaqView',
    component: FaqView,
    meta: {
      title: 'Frequently asked questions - Saverium.dk',
      isPublic: true,
    },
  },
  {
    name: 'LoginView',
    component: LoginView,
    meta: {
      title: 'Login - Saverium.dk',
      isPublic: true,
    },
  },
  {
    name: 'ResetPasswordView',
    component: ResetPasswordView,
    meta: {
      title: 'Reset password - Saverium.dk',
      isPublic: true,
    },
  },
  {
    name: 'SetPasswordView',
    component: SetPasswordView,
    meta: {
      title: 'Set password - Saverium.dk',
      isPublic: true,
    },
  },
  {
    name: 'MyAccountView',
    component: MyAccountView,
    meta: {
      title: 'My account - Saverium.dk',
      requireLogin: true,
    },
  },
  {
    name: 'LogoutView',
    component: LogoutView,
    meta: {
      title: 'Saverium.dk',
      isPublic: true,
    },
  },
  {
    name: 'TosView',
    component: TosView,
    meta: {
      title: 'Saverium.dk',
      isPublic: true,
    },
  },
  {
    name: 'PrivacyPolicyView',
    component: PrivacyPolicyView,
    meta: {
      title: 'Saverium.dk',
      isPublic: true,
    },
  },
]

let rawRoutes = routeUtils.createRawRoutes(langRoutes, localizedPaths)

export default rawRoutes
